// Pulse line used on the "View full history" action. Decorative — always paired
// with a visible label, so it is aria-hidden. Size via CSS font-size (renders at
// 1em); color via currentColor.
export function ActivityIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  );
}
